import { defineMessages } from 'react-intl';

export const messages: {
	applyButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cancelButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	customizeButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	applyButtonLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.apply-button.label',
		description: 'Label for the apply button in the more apps component in the navigation ribbon.',
		defaultMessage: 'Apply',
	},
	cancelButtonLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.cancel-button.label',
		description: 'Label for the cancel button in the more apps component in the navigation ribbon.',
		defaultMessage: 'Cancel',
	},
	customizeButtonLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.customize-button.label',
		description:
			'Label for the customize button in the more apps component in the navigation ribbon.',
		defaultMessage: 'Customize',
	},
});
